/**
 * @param showContainer {boolean}
 * @param containerClass {string}
 * @param additionalText {string}
 * @param additionalTextClass {string}
 * @param children
 */
const socialContainer = ({showContainer, containerClass, additionalText, additionalTextClass, children}) => {
  let container = null;
  if (showContainer) {
    container = (
      <>
        <div className={containerClass}>{children}</div>
        <span className={additionalTextClass}>{additionalText}</span>
      </>
    );
  }
  return container;
};

export default socialContainer;
